import { createSelector } from "reselect";
import { useSelector } from "react-redux";
import { useMemo } from "react";

const makeSelector = (path) =>
    createSelector(
        (state) => state,
        (state) => resolveObj(path, state)
    );

export const useStateSelector = (path = "") => {
    const selector = useMemo(() => makeSelector(path), [path]);
    return useSelector(selector);
};
export const resolveObj = (path, obj) => {
    return path?.split(".").reduce((cache, curr) => {
        return cache ? cache[curr] : null;
    }, obj);
};
